import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inbox from "@/pages/Inbox";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import Properties from "@/pages/Properties";
import Visits from "@/pages/Visits";
import Campaigns from "@/pages/Campaigns";
import AiSettings from "@/pages/AiSettings";
import Simulator from "@/pages/Simulator";
import WhatsApp from "@/pages/WhatsApp";
import Reports from "@/pages/Reports";
import Team from "@/pages/Team";
import SettingsPage from "@/pages/Settings";
import AdminTenants from "@/pages/AdminTenants";
import AdminPlans from "@/pages/AdminPlans";
import PublicLink from "@/pages/PublicLink";
import Privacy from "@/pages/Privacy";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-muted-foreground" data-testid="auth-loading">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={user.role === "superadmin" ? "/admin" : "/"} replace />;
  return children;
}

const T = ["admin", "manager", "broker"];
const S = ["admin", "manager"];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/l/:slug/:type/:code" element={<PublicLink />} />
          <Route path="/privacidade/:slug" element={<Privacy />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Protected roles={T}><Dashboard /></Protected>} />
            <Route path="/inbox" element={<Protected roles={T}><Inbox /></Protected>} />
            <Route path="/leads" element={<Protected roles={T}><Leads /></Protected>} />
            <Route path="/leads/:id" element={<Protected roles={T}><LeadDetail /></Protected>} />
            <Route path="/imoveis" element={<Protected roles={T}><Properties /></Protected>} />
            <Route path="/visitas" element={<Protected roles={T}><Visits /></Protected>} />
            <Route path="/links" element={<Protected roles={S}><Campaigns /></Protected>} />
            <Route path="/ia" element={<Protected roles={S}><AiSettings /></Protected>} />
            <Route path="/simulador" element={<Protected roles={S}><Simulator /></Protected>} />
            <Route path="/whatsapp" element={<Protected roles={S}><WhatsApp /></Protected>} />
            <Route path="/relatorios" element={<Protected roles={S}><Reports /></Protected>} />
            <Route path="/equipe" element={<Protected roles={S}><Team /></Protected>} />
            <Route path="/configuracoes" element={<Protected roles={["admin"]}><SettingsPage /></Protected>} />
            <Route path="/admin" element={<Protected roles={["superadmin"]}><AdminTenants /></Protected>} />
            <Route path="/admin/planos" element={<Protected roles={["superadmin"]}><AdminPlans /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
